"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMerkleClaimer = void 0;
var react_1 = require("react");
var _shared_1 = require("../shared");
var utils_1 = require("../shared/utils");
var multicall_1 = require("../shared/utils/multicall");
var MerkleClaimer_json_1 = __importDefault(require("./MerkleClaimer.json"));
var abi = MerkleClaimer_json_1.default;
function useMerkleClaimer(address, account, 
// claims for account
claims) {
    var web3 = (0, _shared_1.useWeb3Provider)().targetChainWeb3;
    var _a = (0, react_1.useState)(), claimer = _a[0], setClaimer = _a[1];
    var _b = (0, react_1.useState)({}), isClaimed = _b[0], setIsClaimed = _b[1];
    var _c = (0, react_1.useState)(false), isPaused = _c[0], setIsPaused = _c[1];
    var _d = (0, react_1.useState)(), isClaiming = _d[0], setIsClaiming = _d[1];
    var claimsDep = claims.map(function (c) { return c.index; }).join();
    (0, react_1.useEffect)(function () {
        if (!web3)
            return;
        var contract = new web3.eth.Contract(abi, address);
        setClaimer(contract);
        contract.methods.isPaused().call().then(setIsPaused);
    }, [web3, address]);
    (0, react_1.useEffect)(function () {
        if (!claimer || !account || !claims.length)
            return;
        var indexes = claims.map(function (c) { return c.index; });
        var calls = indexes.map(function (index) { return ({
            address: address,
            name: 'isClaimed',
            params: [index],
        }); });
        (0, multicall_1.multicallv2)({
            web3: web3,
            calls: calls,
            abi: abi,
            options: { unwrapValues: true },
        }).then(function (results) {
            (0, utils_1.debug)("Merkle claims for ".concat(account), {
                indexes: indexes,
                calls: calls,
                results: results,
            });
            // @ts-expect-error
            var res = results.reduce(function (acc, v, k) {
                acc[indexes[k]] = v;
                return acc;
            }, {});
            setIsClaimed(res);
        });
    }, [claimer, account, claimsDep]);
    function claim(index) {
        return __awaiter(this, void 0, void 0, function () {
            var claim;
            return __generator(this, function (_a) {
                claim = claims.find(function (c) { return c.index === index; });
                if (!claim) {
                    throw new Error('Claimer not found');
                }
                setIsClaiming(index);
                return [2 /*return*/, claimer.methods
                        .claim(index, account, claim.amount, claim.time, claim.proof)
                        .send({ from: account })
                        .finally(function () { return setIsClaiming(undefined); })];
            });
        });
    }
    return {
        claim: claim,
        claims: claims || [],
        address: address,
        chain: 'ETH',
        isClaimed: isClaimed,
        isPaused: isPaused,
        isClaiming: isClaiming,
    };
}
exports.useMerkleClaimer = useMerkleClaimer;
